import React from 'react';
import {Scrollbar, Flex, Text} from '@priority-software/priority-style-react';
import {isRTLString} from '@priority-software/priority-utils/lib/strings';
import classNames from 'classnames';
import {FilterTextValues} from '../utils/personalization';
import styles from '../styles/SuggestedSearchesDialog.module.scss';
import {configuration} from '../../../services/indexDB/indexeddbServiceSearches';
import {getTopDialogZindex} from '../../../_shared/GWTBridge/invoke/priModalDlg';
import {isRTL} from '../../../Localization';
import {Tooltip} from '../../../components/Common/Tooltip/index';

interface Props {
    filters: FilterTextValues[];
}

const FilterValue = ({filter}) => {
    if (filter.type !== 'text') {
        return (
            <Text
                componentClasses={classNames({
                    [(styles.booleanMargin, styles.operator)]: filter.type === 'bool',
                    [styles.ltrValueStyles]: isRTL() && !isRTLString(filter.values)
                })}
                skin="paragraph-2"
                textColor="primary-700"
            >
                {filter.values}
            </Text>
        );
    } else {
        const index = configuration.maxValuesToDisplay;
        if (filter.values.length <= index) {
            return (
                <Text skin="paragraph-2" textColor="primary-700">
                    {filter.values.join(', ')}
                </Text>
            );
        } else {
            const valsToDisplay = filter.values.slice(0, index).join(', ');
            const tooltipValues = filter.values.slice(index);
            return (
                <>
                    <Text skin="paragraph-2" textColor="primary-700">
                        {`${valsToDisplay} `}
                    </Text>
                    <Tooltip
                        tooltip={tooltipValues.join(', ')}
                        position="top center"
                        zIndex={getTopDialogZindex()}
                    >
                        <Text
                            componentClasses={styles.tooltipTriger}
                            skin="paragraph-2"
                            textColor="primary-700"
                        >
                            {`(+${tooltipValues.length})`}
                        </Text>
                    </Tooltip>
                </>
            );
        }
    }
};

const ListItems = ({filters}) => {
    return filters.map(filter => {
        return (
            <Flex
                justifyContent="flex-start"
                componentClasses={styles.filterWrapper}
                key={filter.field}
            >
                <Text
                    componentClasses={styles.fieldTitle}
                    skin="paragraph-2"
                    textColor="primary-700"
                >
                    {filter.field}
                </Text>
                {filter.type !== 'bool' && filter.operatorText && (
                    <Text
                        componentClasses={styles.operator}
                        skin="paragraph-2"
                        textColor="primary-700"
                    >
                        {filter.operatorText}
                    </Text>
                )}
                {filter.values && <FilterValue filter={filter} />}
            </Flex>
        );
    });
};

export const FiltersList = ({filters}: Props) => {
    return filters.length <= 4 ? (
        <ListItems filters={filters} />
    ) : (
        <Scrollbar autoHide={false} autoHeight autoHeightMax={250}>
            <div className={styles.filtersList}>
                <ListItems filters={filters} />
            </div>
        </Scrollbar>
    );
};
